import { action, computed, observable } from 'mobx';

import { InputHighlight } from '../types';
import request from '../common/utils/Request';

class ResetPasswordStore {
  private static _instance: ResetPasswordStore;

  @observable public awaitServer: boolean = false;
  @observable public confirmPassword: string = '';
  @observable public confirmPasswordBlurred: boolean = false;
  @observable public confirmPasswordValid: boolean = false;
  @observable public password: string = '';
  @observable public passwordBlurred: boolean = false;
  @observable public passwordValid: boolean = false;
  
  /**
   * Use ResetPasswordStore.instance to retrieve an instance of this class.
   */
  private constructor() { }

  /**
   * Instance of ResetPasswordStore.
   */
  public static get instance() {
    if (!this._instance) {
      this._instance = new ResetPasswordStore();
    }

    return this._instance;
  }
  
  /**
   * Check if password is in valid format.
   */
  @computed
  public get isPasswordValid(): boolean {
    return !this.passwordBlurred ? true : this.password.length >= 8;
  }

  /**
   * Get the help message for password if necessary.
   */
  @computed
  public get passwordHelpMessage(): string {
    return this.isPasswordValid ? '' : 'Please enter a valid password';
  }

  /**
   * Get the proper highlight colour for the password field.
   */
  @computed
  public get passwordHighlight(): InputHighlight {
    return this.isPasswordValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }
  
  /**
   * Check if confirm password is identical to password
   */
  @computed
  public get isConfirmPasswordValid(): boolean {
    return this.password === this.confirmPassword;
  }

  /**
   * Get the help message for confired password if necessary.
   */
  @computed
  public get confirmPasswordHelpMessage(): string {
    return this.isConfirmPasswordValid ? '' : 'Password does not match';
  }

  /**
   * Get the proper highlight colour for the confirm password field.
   */
  @computed
  public get confirmPasswordHighlight(): InputHighlight {
    return this.isConfirmPasswordValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  /**
   * Check all fields on the page and see if we can submit now.
   */
  @computed
  public get isReadyForSubmit(): boolean {
    return this.isPasswordValid && this.isConfirmPasswordValid;
  }

  /**
   * Send request to server and return status code
   */
  @action
  public resetPassword = async (uid: string, token: string) => {
    const jsonData = { uid, token, new_password: this.password };

    this.awaitServer = true;
    await request.post('/auth/password/reset/confirm/', jsonData);
  }
}

export default ResetPasswordStore;
export const resetPasswordStore = ResetPasswordStore.instance;


// WEBPACK FOOTER //
// ./src/stores/ResetPasswordStore.ts